import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {compose} from 'redux';
import Panel from '@spothero/ui/panel';
import withConfig from 'config/withConfig';

export const FAQPanels = ({
    cancellationAllowed,
    isMonthly,
    phoneNumber,
    phoneNumberFriendly,
    monthlyPhoneNumber,
    monthlyPhoneNumberFriendly,
    hours,
    siteUrl,
}) => {
    const phoneText = isMonthly
        ? monthlyPhoneNumberFriendly
        : phoneNumberFriendly;
    const phoneHref = isMonthly ? monthlyPhoneNumber : phoneNumber;

    return (
        <div className="FAQPanels">
            {cancellationAllowed !== 'no' && (
                <Panel title="Free Cancellation Policy" showTitleToggle>
                    <p>
                        At this facility, you have up until the minute your
                        reservation begins to cancel your parking for a full
                        refund. You can cancel your reservation on the SpotHero
                        website or app.
                    </p>
                    <p>
                        If you&apos;re having trouble with your reservation and
                        it&apos;s after the start time, please reach out to our
                        Customer Heroes who are more than happy to help rectify
                        any situation!
                    </p>
                </Panel>
            )}
            <Panel title="365-Day Customer Support" showTitleToggle>
                <p>
                    SpotHero has your back. If you have any issues while
                    parking, please call our Customer Heroes immediately at{' '}
                    <a className="support-phone" href={`tel:${phoneHref}`}>
                        {phoneText}
                    </a>
                    . We&apos;re here 365 days a year,{' '}
                    <span className="support-hours">{hours}</span>.
                </p>
                <p>
                    For non-urgent issues shoot us an email at{' '}
                    <a href="mailto:support@spothero.com">
                        support@spothero.com
                    </a>
                    . We&apos;ll get back you within 24 hours.
                </p>
            </Panel>
            <Panel title="Guaranteed Parking by SpotHero" showTitleToggle>
                <p>
                    When you pay with SpotHero, we guarantee you will have a
                    spot to park in, at the price you paid, or your money back.
                </p>
                <p>
                    If a parking facility is ever full when you arrive, call us
                    immediately! We&apos;ll rebook your parking at the closest
                    available nearby facility at no extra charge, or give you a
                    full refund. We&apos;ll also reach out to our partner to
                    prevent this from happening again.
                </p>
                <p>
                    For specifics, please refer to the{' '}
                    <a href={`${siteUrl}/spothero-parking-guarantee/`}>
                        SpotHero Parking Guarantee
                    </a>
                </p>
            </Panel>
        </div>
    );
};

FAQPanels.propTypes = {
    cancellationAllowed: PropTypes.string,
    isMonthly: PropTypes.bool,
    phoneNumber: PropTypes.string,
    phoneNumberFriendly: PropTypes.string,
    monthlyPhoneNumber: PropTypes.string,
    monthlyPhoneNumberFriendly: PropTypes.string,
    hours: PropTypes.string,
    siteUrl: PropTypes.string.isRequired,
};

const mapStateToProps = state => {
    const {
        searchRequest: {monthly: isMonthly},
        city: {
            data: {
                phone_number: phoneNumber,
                phone_number_friendly: phoneNumberFriendly,
                monthly_phone_number: monthlyPhoneNumber,
                monthly_phone_number_friendly: monthlyPhoneNumberFriendly,
                weekday_hours: hours,
            },
        },
    } = state;

    return {
        isMonthly,
        phoneNumber,
        phoneNumberFriendly,
        monthlyPhoneNumber,
        monthlyPhoneNumberFriendly,
        hours,
    };
};

const enhance = compose(withConfig(['siteUrl']), connect(mapStateToProps));

export default enhance(FAQPanels);
